import { Routes } from '@angular/router';
import {
  hasCompletedAllSelectedQuotesGuard,
  hasCompletedItemsGuard,
  hasCustomerDetailsGuard,
} from '@checkout/data-access';
import { CheckoutFeature, CheckoutRoutes } from '@checkout/util-models';
import {
  authenticatingGuard,
  unauthenticatedGuard,
} from '@domgen/dgx-fe-authentication';
import {
  hasBasketItemsGuard,
  selectedPaymentTypeGuard,
  selectedQuotesHaveMultiplePaymentTypesGuard,
  selectedQuotesHavePaymentTypeGuard,
} from '@domgen/dgx-fe-basket';
import { PaymentType } from '@domgen/dgx-fe-common';
import { FeatureEnabledGuard } from '@domgen/dgx-fe-config';

export const CHECKOUT_SHELL_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('@checkout/feature-landing').then(
        (module) => module.LANDING_ROUTES
      ),
    data: {
      redirectTo: CheckoutRoutes.PersonalDetails,
      feature: CheckoutFeature.Landing,
    },
    canActivate: [
      hasBasketItemsGuard,
      FeatureEnabledGuard,
      unauthenticatedGuard,
    ],
    canDeactivate: [authenticatingGuard],
  },
  {
    path: 'personal-details',
    loadChildren: () =>
      import('@checkout/feature-personal-details').then(
        (module) => module.PERSONAL_DETAILS_ROUTES
      ),
    data: {
      redirectTo: CheckoutRoutes.PaymentMethod,
      feature: CheckoutFeature.PersonalDetails,
    },
    canActivate: [
      FeatureEnabledGuard,
      hasBasketItemsGuard,
      unauthenticatedGuard,
    ],
  },
  {
    path: 'marketing-preferences',
    loadChildren: () =>
      import('@checkout/feature-marketing-preferences').then(
        (module) => module.MARKETING_PREFERENCES_ROUTES
      ),
    data: {
      redirectTo: CheckoutRoutes.PaymentMethod,
      feature: CheckoutFeature.MarketingPreferences,
    },
    canActivate: [
      FeatureEnabledGuard,
      hasBasketItemsGuard,
      unauthenticatedGuard,
    ],
  },
  {
    path: 'payment-method',
    loadChildren: () =>
      import('@checkout/feature-payment-method').then(
        (module) => module.PAYMENT_METHOD_ROUTES
      ),
    canActivate: [
      hasBasketItemsGuard,
      hasCustomerDetailsGuard,
      selectedQuotesHaveMultiplePaymentTypesGuard,
    ],
  },
  {
    path: 'card',
    loadChildren: () =>
      import('@checkout/feature-card').then((module) => module.CARD_ROUTES),
    data: {
      paymentType: PaymentType.Card,
    },
    canActivate: [
      hasBasketItemsGuard,
      hasCustomerDetailsGuard,
      selectedPaymentTypeGuard,
      selectedQuotesHavePaymentTypeGuard,
    ],
  },
  {
    path: 'direct-debit',
    loadChildren: () =>
      import('@checkout/feature-direct-debit').then(
        (module) => module.DIRECT_DEBIT_ROUTES
      ),
    data: {
      paymentType: PaymentType.DirectDebit,
    },
    canActivate: [
      hasBasketItemsGuard,
      hasCustomerDetailsGuard,
      selectedPaymentTypeGuard,
      selectedQuotesHavePaymentTypeGuard,
    ],
  },
  {
    path: 'ineligible',
    loadChildren: () =>
      import('@checkout/feature-ineligible').then(
        (module) => module.INELIGBLE_ROUTES
      ),
    canActivate: [hasBasketItemsGuard, hasCustomerDetailsGuard],
  },
  {
    path: 'order-confirmation',
    loadChildren: () =>
      import('@checkout/feature-order-confirmation').then(
        (module) => module.ORDER_CONFIRMATION_ROUTES
      ),
    canActivate: [hasCompletedItemsGuard, hasCompletedAllSelectedQuotesGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
